<template>
    <div>
        <router-link tag="a" class="back-button right mb11" to="/portfolio">Back to portfolio</router-link>
        <h2 class="main-headline">CLIENT LIST</h2>
        <p class="subheadline">In our 30+ years, our projects have been featured across the U.S., Canada and
            <br/> Mexico, everywhere from stadiums and venues to schools, churches,
            <br/> parks, military venues and other community gathering spaces. Listed
            <br/> below is our complete client list organized by state.
        </p>

        <span class="select-title">Select a State:</span>
        <div class="select-wrapper">
            <div class="select-inner">
                <select v-model="selectedState">
                    <option v-for="sCode in statesList" v-bind:value="sCode">{{ sCode }}</option>
                </select>
            </div>
        </div>

        <div class="clients-list-container">
            <template v-if="selectedListCount >= maxNumForSingleColumn">
                <div class="clients-list-left">
                    <template v-for="(client, idx) in selectedList">
                        <span v-if="idx < Math.ceil(selectedListCount / 2)">
                            <!--{{ idx }}:-->
                            {{ client }}
                        </span>
                    </template>
                </div>
                <div class="clients-list-right">
                    <template v-for="(client, idx) in selectedList">
                        <span v-if="idx >= Math.ceil(selectedListCount / 2)">
                            <!--{{ idx }}:-->
                            {{ client }}
                        </span>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="clients-list">
                    <template v-for="(client, idx) in selectedList">
                        <span>{{ client }}</span>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import { mapState, mapGetters } from 'vuex'

    export default {
        name: 'client-list',
        metaInfo: {
            title: 'Client List',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'In our 30+ years our projects have been featured across the U.S., Canada and Mexico. Here is complete client list organized by state.'
                }
            ]
        },
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
        },
        created: function () {
        },
        mounted: function () {
            this.selectedState = this.firstAvailableState
        },
        beforeDestroy: function () {
        },
        watch: {
        },
        methods: {
            getDefaultData: function () {
                return {
                    selectedState: '',
                    maxNumForSingleColumn: 25
                }
            },
            onStateChange: function (countryCode) {
                console.log('onCountryChange', countryCode);
                this.selectedState = countryCode;
            }

        },
        computed: {
            ...mapState([
                'clients-list'
            ]),
            statesList: function () {
                var keys = Object.keys(this['clients-list']);
                var intIndex = keys.indexOf('International');
                if (intIndex !== -1) {
                    keys.splice(intIndex);
                    keys.push('International');
                }
                keys.push('All');
                return keys;
            },
            firstAvailableState: function () {
                // to pre-select first element in the drop-down
                return this.statesList[0];
            },
            selectedList: function () {
                var list = [];
                if (this.selectedState in this['clients-list']) {
                    list = this['clients-list'][this.selectedState];
                } else if (this.selectedState === 'All') {
                    for (var location in this['clients-list']) {
                        list = list.concat(this['clients-list'][location]);
                    }
                    list.sort();
                }
                return list;
            },
            selectedListCount: function () {
                return this.selectedList.length;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Clients.vue?913e0b58